import {create} from "zustand";
import {Product, ProductData} from "@/entities/product";

export type StoreState = {
    opened: boolean;
    product: Product | null;
    productDataCurrent: ProductData | null,

    actions: {
        openModal: () => void;
        closeModal: () => void;
        setProduct: (product: Product) => void;
        setProductDataCurrent: (productDataCurrent: ProductData) => void;
    };
};

export const useAddProductInBasketStore = create<StoreState>((set) => ({
    opened: false,
    product: null,
    productDataCurrent: null,

    actions: {
        openModal: () => set({opened: true}),
        closeModal: () => set({product: null, productDataCurrent: null, opened: false}),
        setProduct: (product) => set({product}),
        setProductDataCurrent: (productDataCurrent) => set({productDataCurrent}),
    },
}));
